// src/config/stripe.js
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

export const DEFAULT_PRICE_ID =
  process.env.REACT_APP_STRIPE_PRICE_ID || "";

// (Optional) if you want a loud failure in dev:
if (!STRIPE_PUBLISHABLE_KEY) {
  // eslint-disable-next-line no-console
  console.warn("Stripe publishable key is not set in environment variables.");
}